// extracted by mini-css-extract-plugin
export default {"MOBILE_BREAKPOINT":"0","TABLET_BREAKPOINT":"768","LAPTOP_BREAKPOINT":"960","DESKTOP_BREAKPOINT":"1320"};